<template>
  <a-modal
    :title="title"
    :width="780"
    :visible="visible"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="名称"/>
            </a-form-item>
            <a-form-item label="内容">
              <a-textarea :rows="4" v-decorator="['content', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['name', 'content']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.model)

    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  mounted () {
    console.log('custom modal mounted', this.model)
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.form.resetFields()
        })
      }
    }
  },
  computed: {
    title () {
      if (this.model !== undefined) {
        return '修改'
      } else {
        return '新建'
      }
    }
  },
  methods: {
    ok () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.$emit('ok', values)
        }
      })
    }
  }
}
</script>
